import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ThemeState {
  isDark: boolean;
}

const getInitialTheme = (): boolean => {
  if (typeof window !== "undefined") {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? JSON.parse(savedTheme) : false;
  }
  return false;
};

const initialState: ThemeState = {
  isDark: getInitialTheme(),
};
export const THEME_SLICE_KEY = "theme";

export const themeSlice = createSlice({
  name: THEME_SLICE_KEY,
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isDark = !state.isDark;
      localStorage.setItem("theme", JSON.stringify(state.isDark));
    },
    setTheme: (state, action: PayloadAction<boolean>) => {
      state.isDark = action.payload;
      localStorage.setItem("theme", JSON.stringify(state.isDark));
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
